<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1_72)">
      <rect x="10" y="5" width="80" height="80" rx="40" fill="#EEDBCC" />
      <rect x="11" y="6" width="78" height="78" rx="39" stroke="#293C5A" stroke-width="2" />
    </g>
    <path d="M12.0149 25.2666H88.0469V30.3212H12.0149V25.2666Z" fill="#8CA4B8" />
    <path
      d="M86.1461 25.2666H13.9157C13.4116 25.2666 12.9281 25.4441 12.5716 25.7601C12.2152 26.0761 12.0149 26.5046 12.0149 26.9515V28.6363C11.995 28.7762 11.995 28.9177 12.0149 29.0575C12.1227 28.6868 12.3696 28.3597 12.7151 28.13C13.0606 27.9003 13.4841 27.7818 13.9157 27.7939H86.1461C86.5778 27.7818 87.0012 27.9003 87.3467 28.13C87.6922 28.3597 87.9392 28.6868 88.047 29.0575C88.0668 28.9177 88.0668 28.7762 88.047 28.6363V26.9515C88.047 26.5046 87.8467 26.0761 87.4902 25.7601C87.1338 25.4441 86.6503 25.2666 86.1461 25.2666Z"
      fill="#ADC4D9"
    />
    <path
      d="M12.0149 25.2666H88.0469V30.3212H12.0149V25.2666Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9157 30.3212H86.1462V73.2848C86.1462 73.7316 85.9459 74.1602 85.5895 74.4762C85.233 74.7921 84.7495 74.9696 84.2454 74.9696H15.8165C15.3124 74.9696 14.8289 74.7921 14.4725 74.4762C14.116 74.1602 13.9157 73.7316 13.9157 73.2848V30.3212Z"
      fill="white"
    />
    <path d="M13.9157 30.3212H86.1462V34.1121H13.9157V30.3212Z" fill="#E0E0E0" />
    <path
      d="M13.9157 30.3212H86.1462V73.2848C86.1462 73.7316 85.9459 74.1602 85.5895 74.4762C85.233 74.7921 84.7495 74.9696 84.2454 74.9696H15.8165C15.3124 74.9696 14.8289 74.7921 14.4725 74.4762C14.116 74.1602 13.9157 73.7316 13.9157 73.2848V30.3212Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M30.0725 21.0545H69.9894V74.9697H30.0725V21.0545Z" fill="white" />
    <path d="M30.0725 21.0545H69.9894V24.0704H30.0725V21.0545Z" fill="#E0E0E0" />
    <path
      d="M30.0725 21.0545H69.9894V74.9697H30.0725V21.0545Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M38.6261 56.4364H61.4358V74.9697H38.6261V56.4364Z" fill="#00B8F0" />
    <path
      d="M43.2641 74.9697H53.1483L61.4358 57.1609V56.4364H51.8747L43.2641 74.9697Z"
      fill="#4ACFFF"
    />
    <path
      d="M38.6261 56.4364H61.4358V74.9697H38.6261V56.4364Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M36.7254 50.5393H63.3366V56.4363H36.7254V50.5393Z" fill="#8CA4B8" />
    <path
      d="M61.4357 50.5393H38.6261C38.122 50.5393 37.6385 50.7168 37.282 51.0328C36.9256 51.3488 36.7253 51.7773 36.7253 52.2242V54.7515C36.7167 54.8186 36.7167 54.8865 36.7253 54.9536C36.7856 54.5457 37.0122 54.1715 37.3624 53.9015C37.7125 53.6315 38.162 53.4843 38.6261 53.4878H61.4357C61.8998 53.4843 62.3493 53.6315 62.6995 53.9015C63.0496 54.1715 63.2762 54.5457 63.3365 54.9536C63.3452 54.8865 63.3452 54.8186 63.3365 54.7515V52.2242C63.3365 51.7773 63.1363 51.3488 62.7798 51.0328C62.4233 50.7168 61.9398 50.5393 61.4357 50.5393Z"
      fill="#ADC4D9"
    />
    <path
      d="M36.7254 50.5393H63.3366V56.4363H36.7254V50.5393Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M28.1718 16H71.8902V21.0545H28.1718V16Z" fill="#8CA4B8" />
    <path
      d="M69.9894 16H30.0726C29.5684 16 29.085 16.1775 28.7285 16.4935C28.372 16.8095 28.1718 17.238 28.1718 17.6848V19.3697C28.183 19.5131 28.215 19.6547 28.2668 19.7909C28.3706 19.4343 28.6034 19.1176 28.9295 18.8894C29.2556 18.6612 29.6571 18.534 30.0726 18.5273H69.9894C70.421 18.5152 70.8445 18.6337 71.19 18.8634C71.5355 19.0931 71.7824 19.4202 71.8902 19.7909C71.9101 19.6511 71.9101 19.5095 71.8902 19.3697V17.6848C71.8902 17.238 71.6899 16.8095 71.3334 16.4935C70.977 16.1775 70.4935 16 69.9894 16Z"
      fill="#ADC4D9"
    />
    <path
      d="M28.1718 16H71.8902V21.0545H28.1718V16Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.6837 32.0061H53.8325C53.5804 32.0061 53.3387 31.9173 53.1604 31.7594C52.9822 31.6014 52.8821 31.3871 52.8821 31.1637V28.6364C52.8821 28.413 52.782 28.1987 52.6037 28.0407C52.4255 27.8827 52.1837 27.794 51.9317 27.794H48.1301C47.878 27.794 47.6363 27.8827 47.458 28.0407C47.2798 28.1987 47.1797 28.413 47.1797 28.6364V31.1637C47.1797 31.3871 47.0795 31.6014 46.9013 31.7594C46.7231 31.9173 46.4813 32.0061 46.2293 32.0061H43.3781C43.126 32.0061 42.8843 32.0948 42.706 32.2528C42.5278 32.4108 42.4277 32.6251 42.4277 32.8485V36.2182C42.4277 36.4416 42.5278 36.6559 42.706 36.8139C42.8843 36.9719 43.126 37.0606 43.3781 37.0606H46.2293C46.4813 37.0606 46.7231 37.1494 46.9013 37.3074C47.0795 37.4654 47.1797 37.6796 47.1797 37.9031V40.4303C47.1797 40.6538 47.2798 40.868 47.458 41.026C47.6363 41.184 47.878 41.2728 48.1301 41.2728H51.9317C52.1837 41.2728 52.4255 41.184 52.6037 41.026C52.782 40.868 52.8821 40.6538 52.8821 40.4303V37.9031C52.8821 37.6796 52.9822 37.4654 53.1604 37.3074C53.3387 37.1494 53.5804 37.0606 53.8325 37.0606H56.6837C56.9357 37.0606 57.1775 36.9719 57.3557 36.8139C57.534 36.6559 57.6341 36.4416 57.6341 36.2182V32.8485C57.6341 32.6251 57.534 32.4108 57.3557 32.2528C57.1775 32.0948 56.9357 32.0061 56.6837 32.0061Z"
      fill="#FF6242"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M19.6181 34.5333H24.3701V42.1151H19.6181V34.5333Z" fill="#00B8F0" />
    <path
      d="M20.5685 42.1151H23.4197C23.6717 42.1151 23.9135 42.0264 24.0917 41.8684C24.2699 41.7104 24.3701 41.4961 24.3701 41.2727V35.3757C24.3646 35.1915 24.2912 35.0139 24.161 34.8703L19.9412 41.8961C20.1121 42.036 20.3359 42.1141 20.5685 42.1151Z"
      fill="#4ACFFF"
    />
    <path d="M19.6181 46.3272H24.3701V53.9091H19.6181V46.3272Z" fill="#00B8F0" />
    <path
      d="M20.5685 53.9091H23.4197C23.6717 53.9091 23.9135 53.8203 24.0917 53.6623C24.2699 53.5043 24.3701 53.2901 24.3701 53.0666V47.1697C24.3646 46.9854 24.2912 46.8079 24.161 46.6642L19.9412 53.69C20.1121 53.8299 20.3359 53.908 20.5685 53.9091Z"
      fill="#4ACFFF"
    />
    <path d="M19.6181 58.1212H24.3701V65.703H19.6181V58.1212Z" fill="#00B8F0" />
    <path
      d="M20.5685 65.703H23.4197C23.6717 65.703 23.9135 65.6142 24.0917 65.4562C24.2699 65.2982 24.3701 65.084 24.3701 64.8605V58.9636C24.3646 58.7794 24.2912 58.6018 24.161 58.4581L19.9412 65.4839C20.1121 65.6238 20.3359 65.702 20.5685 65.703Z"
      fill="#4ACFFF"
    />
    <path
      d="M19.6181 34.5333H24.3701V42.1151H19.6181V34.5333ZM19.6181 46.3272H24.3701V53.909H19.6181V46.3272ZM19.6181 58.1212H24.3701V65.703H19.6181V58.1212Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M75.6918 34.5333H80.4438V42.1151H75.6918V34.5333Z" fill="#00B8F0" />
    <path
      d="M76.6421 42.1151H79.4933C79.7454 42.1151 79.9871 42.0264 80.1654 41.8684C80.3436 41.7104 80.4437 41.4961 80.4437 41.2727V35.3757C80.4383 35.1915 80.3649 35.0139 80.2347 34.8703L76.0149 41.8961C76.1858 42.036 76.4095 42.1141 76.6421 42.1151Z"
      fill="#4ACFFF"
    />
    <path d="M75.6918 46.3272H80.4438V53.9091H75.6918V46.3272Z" fill="#00B8F0" />
    <path
      d="M76.6421 53.9091H79.4933C79.7454 53.9091 79.9871 53.8203 80.1654 53.6623C80.3436 53.5043 80.4437 53.2901 80.4437 53.0666V47.1697C80.4383 46.9854 80.3649 46.8079 80.2347 46.6642L76.0149 53.69C76.1858 53.8299 76.4095 53.908 76.6421 53.9091Z"
      fill="#4ACFFF"
    />
    <path d="M75.6918 58.1212H80.4438V65.703H75.6918V58.1212Z" fill="#00B8F0" />
    <path
      d="M76.6421 65.703H79.4933C79.7454 65.703 79.9871 65.6142 80.1654 65.4562C80.3436 65.2982 80.4437 65.084 80.4437 64.8605V58.9636C80.4383 58.7794 80.3649 58.6018 80.2347 58.4581L76.0149 65.4839C76.1858 65.6238 76.4095 65.702 76.6421 65.703Z"
      fill="#4ACFFF"
    />
    <path
      d="M50.0309 56.4363V74.9696M75.6917 34.5333H80.4437V42.1151H75.6917V34.5333ZM75.6917 46.3272H80.4437V53.909H75.6917V46.3272ZM75.6917 58.1212H80.4437V65.703H75.6917V58.1212Z"
      stroke="#45413C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_1_72"
        x="0"
        y="0"
        width="100"
        height="100"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.160784 0 0 0 0 0.235294 0 0 0 0 0.352941 0 0 0 0.35 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_72" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_72" result="shape" />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "LogoSvg",
  props: {
    width: {
      type: Number,
      default: 48,
    },
    height: {
      type: Number,
      default: 48,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>